import React from "react";

import { IgChip } from "@intelligems/ig-theme";
import { AudienceExpressionPayload } from "@intelligems/ig-types";
import Grid from "@mui/material/Grid";

import { formatQueries } from "../utils";

interface ExpressionOverviewProps {
  expressionsList: AudienceExpressionPayload[];
  chipColor?: "info" | "success" | "warning" | "error" | "default" | "accent";
  cutOffAt?: number;
  groupLabelCategories?: boolean;
  onGeneralChipClick?: () => void;
}

export const ExpressionOverview = ({
  expressionsList,
  chipColor,
  cutOffAt,
  groupLabelCategories,
  onGeneralChipClick,
}: ExpressionOverviewProps) => {
  if (expressionsList.length === 0) {
    return null;
  } else
    return (
      <Grid
        container
        direction={"row"}
        columnSpacing={1}
        rowSpacing={1}
        alignItems={"center"}
      >
        {expressionsList.map((expression) => {
          return (
            <Grid key={expression.type}>
              <IgChip
                clickable={onGeneralChipClick !== undefined}
                onClick={onGeneralChipClick}
                color={chipColor || "default"}
                key={expression.type}
                label={`${formatQueries(
                  expression.queries.slice(
                    0,
                    cutOffAt !== undefined &&
                      expression.queries.length > cutOffAt
                      ? cutOffAt
                      : expression.queries.length
                  ),
                  groupLabelCategories
                )} ${!groupLabelCategories && cutOffAt !== undefined && expression.queries.length > cutOffAt ? `+ ${expression.queries.length - cutOffAt} more` : ""}`}
              />
            </Grid>
          );
        })}
      </Grid>
    );
};
